// extracted by mini-css-extract-plugin
export default {"featured-wrapper":"PaymentOption_featured-wrapper__Zck89","featured-label":"PaymentOption_featured-label__axmxX"};